import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import arrowIcon from '../../../images/icons/chevron-up.svg';
import styles from './Accordion.module.sass';
import ClickableDiv from '../clickable_div/ClickableDiv';

class Accordion extends Component {
  constructor(props) {
    super(props);
    const { isOpened } = props || false;
    this.state = { isOpened };
  }

  toggle = () => {
    this.setState((prevState) => ({
      isOpened: !prevState.isOpened,
    }));
  };

  render() {
    const {
      heading, content, background = 'transparent', headingBackground = 'transparent', headingClassName, accordionClassName,
      className,
    } = this.props;
    const { isOpened } = this.state;
    return (
      <div className={`${styles.accordion} ${isOpened ? styles.active : ''} ${className}`}>
        <ClickableDiv className={`${styles.heading} ${styles[headingBackground]} ${headingClassName}`} onClick={this.toggle}>
          { heading }
          <img className={`${styles['arrow-up']} ${isOpened ? styles.open : ''}`} src={arrowIcon} alt="hide or show" />
        </ClickableDiv>
        <AnimateHeight className={`${styles.content} ${styles[background]} ${accordionClassName}`} duration={400} height={isOpened ? 'auto' : 0}>
          { content }
        </AnimateHeight>
      </div>
    );
  }
}

Accordion.propTypes = {
  heading: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  headingBackground: PropTypes.oneOf(['spring-wood', 'transparent', 'transparent-with-border', 'dull-lavender']),
  background: PropTypes.oneOf(['spring-wood', 'transparent']),
  headingClassName: PropTypes.string,
  accordionClassName: PropTypes.string,
  className: PropTypes.string,
};

export default Accordion;
